<template lang="pug">
  booking-form(
    @save="createBooking",
    @cancel="cancelCreateBooking",
    v-loading.fullscreen.lock="fullscreenLoading",
    :booking="booking"
    type="create",
  )
</template>

<style lang="scss" scoped>
</style>

<script>
import Moment from 'moment'

import BookingForm from '@/components/booking/BookingForm'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  name: 'BookingCreate',
  mixins: [GenericAPIHandler],
  data () {
    return {
      fullscreenLoading: false,
      booking: {},
    }
  },
  props: {
    patientId: {
      type: Number,
      required: true,
    },
    reservationId: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.prefillCreateBooking()
  },
  components: {
    BookingForm,
  },
  methods: {
    async prefillCreateBooking () {
      this.fullscreenLoading = true
      try {
        this.booking = await this.$api.Booking.prepareCreate(this.reservationId)
        this.booking.dates = this.booking.dates.filter((event) => {
          return Moment(event).startOf('date').isSameOrAfter(Moment().startOf('date'))
        })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
        document.querySelectorAll('.fc-day').forEach((day) => { day.style.backgroundColor = '#eff0f1' })
      }
    },
    async cancelCreateBooking () {
      this.$router.push({ name: 'PatientDetail', params: { id: this.patientId }, query: { tab: 'workcalendarTab' } })
    },
    async createBooking (booking) {
      this.fullscreenLoading = true
      booking.reservationId = this.reservationId
      try {
        await this.$api.Booking.create(booking)
        this.showSuccessDialog({ name: 'PatientDetail', params: { id: this.patientId }, query: { tab: 'workcalendarTab' } })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
  },
}
</script>
